module.exports = "https://www.gc-qa.gnp.com.mx/b98630af087af44952fda7a4c9627e5c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/localizaN.svg
// module id = 131
// module chunks = 0 1